<template>
  <div class="warranty" @click="log">
    <div class="order">
      <div class="order__product-text">Номенклатура</div>
      <div class="order__product-name">{{warrantyData['NAME']}}</div>
      <div class="order__serial-name">Серійний номер</div>
      <div class="order__seirial-number">{{warrantyData['IMEI']}}</div>
      <div class="order__seller-name">Компанія продавець</div>
      <div class="order__seller-info">ТОВ "ТРЕЙД СЕРВІС ПРОМОУШЕН"</div>
      <div class="order__info">
        <div class="order__sale">
          <div class="order__sale-text">Дата продажу:</div>
          <div class="order__sale-date">{{warrantyData['SALE_DATE']}}</div>
        </div>
        <div class="order__warranty">
          <div class="order__warranty-text">Строк гарантії:</div>
          <div class="order__warranty-date">{{warrantyData['GUARANTEE_DAYS_COUNT']}}д.</div>
        </div>

        <div class="order__warranty">
          <div class="order__warranty-text">Статус гарантії:</div>
          <div class="order__warranty-date"
               :class="warrantyData['GUARANTEE_PERIOD']
                ? 'order__warranty-status-positive'
                 : 'order__warranty-status-negative'"
          >Гарантiя {{warrantyData['GUARANTEE_PERIOD'] ? 'дійсна' : 'недійсна'}}</div>
        </div>
      </div>

      <div class="order__warranty">
        <div class="order__warranty-text">Гарантiя дійсна до:</div>
        <div class="order__warranty-date">{{warrantyData['GUARANTEE_DATE']}}</div>
      </div>

      <div class="press">
        <img class="press-logo" src="../../static/img/icons/press-logo.png" alt="press-logo">
      </div>

      <div class="warranty-ask">
        <div class="ask__text">{{warrantyData['GUARANTEE_PERIOD'] ? 'Звернутись по гарантії:' : 'Звернутись в сервіс'}}</div>
        <img class="ask__qr" src="../../static/img/icons/qr-code.png" alt="qr-code">
      </div>

    </div>
<!--    <div class="wo-logo__transperent">-->
<!--      <img src="../../static/img/icons/wo-transperent.png" alt="wo-logo">-->
<!--    </div>-->
    <div class="warranty-text">
<!--      <div class="wo__logo-right">-->
<!--        <img class="wo__logo" src="../../static/img/icons/wo-black.png" alt="wo-black">-->
<!--      </div>-->
      <h1 class="warranty__main-text">Гарантія, що треба!</h1>
      <div class="warranty-paragraph">Дякуємо, що обрали нас
        <br>
        <br>
        Переконані, користування нашим товаром буде для вас корисним та приємним!
        <br>
        <br>
        Цим документом ми гарантуємо ваше право на безоплатне
        усунення несправностей, які виникли з вини виробника.
        Перед використанням, будь ласка, ознайомтеся з інструкцією,
        аби уникнути незручностей під час експлуатації товару.
        <br>
        <br>
        Ми подбали, аби процес гарантійного обслуговування не
        забирав багато часу та відбувався максимально зручно.
        Заявку на сервіс можна самостійно створити на спеціально
        розробленому сайті <a class="warranty__link" href="https://service.smartgroup.ua">service.smartgroup.ua</a>. Після цього ви
        будете отримувати повідомлення про статус ремонту.
        <br>
        <br>
        Також ми влаштували сервіс так, щоб надавати вам
        консультацію із будь-яких питань онлайн. А ще ви можете
        поставити запитання нашим менеджерам у найпопулярніших
        месенджерах.
        <br>
        <br>
        У нашому сервісному центрі працюють кваліфіковані майстри,
        які обов'язково нададуть висновок про стан вашого товару та
        рекомендації щодо його використання та обслуговування.
      </div>
<!--      <div class="warranty__footer">-->
<!--        <a href="https://wo.ua" target="_blank"><img src="../../static/img/icons/wo_logo.svg" alt="wo logo" class="warranty__small-logo"></a>-->
<!--        <div class="warranty__footer-text">-->
<!--          — не тільки розумні товари, це ще й смарт сервіс і турбота про кожного клієнта!-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="preloader" v-if="warrantyLoading">
      <Preloader/>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Preloader from './Preloader/Preloader'

export default {
  name: 'WarrantyPage',
  components: {
    Preloader
  },
  computed: {
    ...mapGetters({
      warrantyData: 'getWarrantyData',
      warrantyLoading: 'getWarrantyLoading'
    })
  },
  mounted () {
    const {sn} = this.$route.query
    this.$store.dispatch('loadWarrantyData', sn)
  },
  methods: {
    log () {
      console.log(this.warrantyData)
      console.log(this.warrantyLoading)
    }
  }
}
</script>

<style lang="scss" scoped>
.warranty {
  padding: 100px 140px 60px 140px;
  display: flex;
  justify-content: space-between;
  &__footer {
    margin-top: auto;
    &-text {
      font-size: 21px;
      font-family: 'SF UI Text Bold';
      display: inline;
    }
  }
  &__small-logo {
    width: 37px;
    height: 15px;
    path {
      fill: #fff;
    }
  }
}

.order {
  font-family: 'SF UI Text Regular';
  max-width: 50%;
  margin-right: 120px;

  &__product-text, &__serial-name, &__seller-name {
    font-size: 16px;
    font-family: 'SF UI Text Regular';
    padding-bottom: 18px;
    padding-top: 50px;
  }
  &__product-text {
    padding-top: 0;
  }
  &__product-name, &__seirial-number, &__seller-info {
    font-size: 19px;
    font-family: 'SF UI Text Semibold';
  }
  &__info {
    padding-top: 50px;
  }
  &__warranty, &__sale {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__warranty {
    margin-top: 23px;
    &-status-positive {
      color: green;
    }
    &-status-negative {
      color: red;
    }
    &-status-positive::before, &-status-negative::before {
      content: '';
      background: url(../assets/img/icons/check-mark.svg) no-repeat center / contain;
      display: inline-block;
      width: 20px;
      height: 20px;
      vertical-align: middle;
      margin-right: 10px;
    }
    &-status-negative::before {
      background: url(../assets/img/icons/negative.svg) no-repeat center / contain;
      path {
        fill: red;
      }
    }
  }
}

.press-logo {
  display: block;
  margin: 15px auto;
  width: 202px;
  height: 203px;
}

.warranty-text {
  max-width: 50%;
  display: flex;
  flex-direction: column;
}

.warranty__main-text {
  font-size: 24px;
  font-family: 'SF UI Text Bold';
}

.warranty-paragraph {
  font-family: 'SF UI Text Regular';
  font-size: 18px;
  margin-top: 50px;
}

.warranty__link {
  text-decoration: none;
  color: #6334ff;
}

.wo__logo-right {
  position: absolute;
  top: 0;
  right: 0;
  z-index: -1;
}

.wo-logo__transperent {
  position: absolute;
  left: 725px;
  top: 175px;
}

.warranty-ask {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  .no-valid {
    .ask__text {
      border-bottom: 1px solid transparent;
    }
    img {
      opacity: 0;
    }
  }
}

.ask__text {
  font-size: 21px;
  font-family: 'SF UI Text Bold';
  border-bottom: 1px solid #000;
  width: 461px;
}

.preloader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(255,255,255,0.7);
  z-index: 999;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .Preloader {
    width: 100px;
    height: 100px;
  }
}

@media (max-width: 1300px) {

  .order {
    margin-right: 110px;
  }

  .warranty {
    padding: 60px 120px 60px 120px;
  }
  .warranty-paragraph {
    font-family: 'SF UI Text Regular';
    font-size: 17px;
  }
  .wo-logo__transperent {
    left: 620px;
  }

}

@media (max-width: 1200px) {

  .order {
    margin-right: 100px;
  }

  .warranty {
    padding: 60px 110px 60px 110px;
  }
  .warranty-paragraph {
    font-family: 'SF UI Text Regular';
    font-size: 16px;
  }
  .wo-logo__transperent {
    left: 570px;
  }
}

@media (max-width: 1100px) {

  .order {
    margin-right: 80px;
  }

  .warranty {
    padding: 60px 90px 60px 90px;
  }
  .warranty-paragraph {
    font-family: 'SF UI Text Regular';
    font-size: 16px;
  }
  .wo-logo__transperent {
    left: 480px;
  }

}

@media (max-width: 1024px) {
  .order {
    margin-right: 70px;
  }

  .warranty {
    padding: 60px 75px 60px 75px;
  }
  .warranty-paragraph {
    font-family: 'SF UI Text Regular';
    font-size: 16px;
  }
  .wo-logo__transperent {
    left: 435px;
    width: 123px;
    height: 167px;
  }

  .wo__logo{
    width: 126px;
    height: 108px;
  }

  .warranty__footer {
    margin-top: 30px;
  }
  .press-logo {
    width: 199px;
    height: 200px;
  }
  .ask__qr {
    width: 109px;
    height: 109px;
  }
}

@media (max-width: 768px) {
  .order {
    margin-right: 40px;
  }
  .warranty {
    padding: 40px 40px 40px 40px;
  }
  .wo__logo {
    width: 96px;
    height: 78px;
  }
  .warranty-paragraph {
    margin-top: 25px;
  }
  .order__product-text, .order__serial-name {
    font-size: 14px;
  }
  .order__product-name, .order__seirial-number, .order__seller-inf {
    font-size: 17px;
  }
  .ask__text {
    font-size: 16px;
  }
  .wo-logo__transperent {
    left: 360px;
  }
  .wo-logo__transperent img {
    width: 96px;
    height: 96px;
  }

  @media (max-width: 644px) {
    .order__warranty-status-positive::before, .order__warranty-status-negative::before {
      width: 19px;
      height: 19px;
      margin-right: 5px;
    }
  }

  @media (max-width: 499px) {
    .warranty {
      display: block;
    }
    .order {
      margin-right: 0;
      max-width: 100%;
    }
    .press-logo {
      width: 149px;
      height: 150px;
    }
    .ask__qr {
      width: 99px;
      height: 99px;
    }
    .wo-logo__transperent {
      top: 902px;
      left: -19px;
    }
    .warranty-text {
      max-width: 100%;
      margin-top: 60px;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/WarrantyPage.vue